module.exports = __webpack_public_path__ + "static/media/LogoDE.809db784.svg";